exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\r\n  border-top: 1px solid #EDEDED;\r\n  padding: 2.2em 10em;\r\n  margin-top: 2em;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n  height: 8.375em;\r\n  gap: 0.8em;\r\n  font-size: 1.143em;\r\n}\r\n\r\n.row_container {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: justify;\r\n      justify-content: space-between;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n}\r\n\r\n#app_version {\r\n  color: #6A6A6A;\r\n}\r\n\r\n.cookies_actions {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  gap: 2em;\r\n}\r\n\r\n.cookies_actions a {\r\n  color: black;\r\n}\r\n\r\n.cookies_actions a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.cookies_actions button {\r\n  border: none;\r\n  background-color: transparent;\r\n  color: black;\r\n  padding: 0em;\r\n}\r\n\r\n.cookies_actions button:hover {\r\n  text-decoration: underline;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/footer/footer.component.css
// module id = ../../../../../src/app/layout/home/footer/footer.component.css
// module chunks = main